export default {
	functional: true,
	name: 'Tag',
	props: {
		text: {
			type: String,
			require: true,
		},
	},
	render(h, context) {
		return h(
			'span',
			{
				class: 'global-tag',
			},
			context.props.text
		);
	},
};



// WEBPACK FOOTER //
// ./src/components/common/Tag.js